import { useState } from "react";

//This hook will handle the processing of grid buttons in a consistent manner

export default function useGridButtons() {
  const [gridButtons, setGridButtons] = useState([]);
  function AddGridButton(
    buttonText,
    buttonCallback,
    disableWhenNoRecordSelected = true,
    dropdownButtonOptions = null, //specify the options as a comma separated string,  this will cause the button to be rendered as a dropdown button, at least 2 values are required, otherwise it makes no sense to render a dropdown button
    styleOverride = null
  ) {
    let newButton = {
      text: buttonText,
      callback: buttonCallback,
      disableWhenNoRecordSelected: disableWhenNoRecordSelected,
      dropdownButtonOptions: dropdownButtonOptions,
      styleOverride: styleOverride,
    };

    //make sure a button with the same text doesn't already exist

    let existingButton = gridButtons.find(
      (button) => button.text === buttonText
    );
    if (existingButton) {
      //throw new Error("A button with the same text already exists");

      // button already exists, so exit do not add it again
      return;
    }

    setGridButtons((prevButtons) => [...prevButtons, newButton]);
  }

  return { gridButtons, AddGridButton };
}
